import { DismissableCard, Text } from '@sketch/components'
import { breakpoint } from '@sketch/global-styles'
import styled from 'styled-components'

export const StyledDismissableCard = styled(DismissableCard)`
  position: absolute;
  top: 20px;
  right: 20px;
  max-width: 314px;

  ${breakpoint('base', 'xs')`
  margin-left: 20px;
`}
`

export const Message = styled(Text).attrs({
  textStyle: 'copy.secondary.standard.E',
})`
  margin: 0;
`

export const PageContent = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  display: flex;
  flex: 1 0 auto;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.background.secondary.B};

  backface-visibility: hidden;
  perspective: 1000;
  transition: all ${({ theme }) => theme.transitions.duration[3]};
  transition-property: width;
`
